const escapeUrlForMarkdown = (url: string): string => {
    return url
        .replace(/\\/g, '\\\\')
        .replace(/\(/g, '\\(')
        .replace(/\)/g, '\\)')
        .replace(/\[/g, '\\[')
        .replace(/\]/g, '\\]')
        .replace(/&/g, '\\&')
}

const escapeForMarkdownRegex = (value: string) => {
    return value
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace(/&/g, '\\\\?&')
        .replace(/\(/g, '\\\\?\\(')
        .replace(/\)/g, '\\\\?\\)')
        .replace(/!/g, '\\\\?!')
}

export const insertImageMarkdown = (url: string, alt = '') => {
    return `![${alt}](${escapeUrlForMarkdown(url)})`
}

export const replaceResourceIdsWithUrls = (markdown: string, resources: Array<{ id: string; url: string }>) => {
    if (!resources.length) {
        return markdown
    }

    let nextMarkdown = markdown

    resources.forEach((resource) => {
        const pattern = new RegExp(`!\\[(.*?)\\]\\(${escapeForMarkdownRegex(resource.id)}(?:\\s+"(.*?)")?\\)`, 'g')
        nextMarkdown = nextMarkdown.replace(pattern, (_, alt, title) => {
            const titleSegment = title ? ` "${title}"` : ''
            return `![${alt}](${escapeUrlForMarkdown(resource.url)}${titleSegment})`
        })
    })

    return nextMarkdown
}

export const replaceResourceUrlsWithIds = (markdown: string, resources: Array<{ id: string; url: string }>) => {
    if (!resources.length) {
        return markdown
    }

    let nextMarkdown = markdown

    resources.forEach((resource) => {
        const pattern = new RegExp(`!\\[(.*?)\\]\\(${escapeForMarkdownRegex(resource.url)}(?:\\s+"(.*?)")?\\)`, 'g')
        nextMarkdown = nextMarkdown.replace(pattern, (_, alt, title) => {
            const titleSegment = title ? ` "${title}"` : ''
            return `![${alt}](${resource.id}${titleSegment})`
        })
    })

    return nextMarkdown
}
